var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { width: "600" },
      model: {
        value: _vm.resultDialogVisible,
        callback: function ($$v) {
          _vm.resultDialogVisible = $$v
        },
        expression: "resultDialogVisible",
      },
    },
    [
      _c("customDialog", {
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _vm._v(" " + _vm._s("グループを選択してください") + " "),
                _c("button", { attrs: { id: "dialog_exit" } }, [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/images/popup_close.png"),
                      id: "btn_img",
                    },
                    on: {
                      click: function ($event) {
                        _vm.resultDialogVisible = false
                      },
                    },
                  }),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  "v-row",
                  { staticClass: "ma-0 pa-0", attrs: { justify: "center" } },
                  [
                    _c(
                      "v-col",
                      { staticClass: "ma-0 pa-0", attrs: { cols: "10" } },
                      [
                        _c(
                          "v-row",
                          { staticClass: "ma-0 pa-0 mt-2 mb-14" },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0",
                                attrs: {
                                  id: "store_list",
                                  cols: "12",
                                  align: "left",
                                },
                              },
                              _vm._l(_vm.msgList, function (item, index) {
                                return _c(
                                  "v-col",
                                  {
                                    key: index,
                                    staticClass: "ma-0 pa-0",
                                    attrs: { cols: "12" },
                                  },
                                  [_vm._v(" " + _vm._s(item) + " ")]
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          {
                            staticClass: "ma-0 pa-0",
                            attrs: { align: "center", justify: "center" },
                          },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "ma-0 pa-2",
                                attrs: {
                                  width: "8rem",
                                  height: "auto",
                                  id: "blue_btn",
                                  elevation: "0",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.resultDialogVisible = false
                                  },
                                },
                              },
                              [_vm._v(" " + _vm._s("OK") + " ")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }